module.exports = {"BTN_LOGIN":"Login","BTN_RECORD":"Record","BTN_UPDATE":"Save","BTN_CANCEL":"Cancel","BTN_TODAY":"Today","BTN_RELOAD":"Reload","BTN_OK":"OK","BTN_DELETE_CONFIRM":"Confirm","BTN_SAVE_WITHOUT_VALIDATE":"Save without validate","BTN_SAVE_WITHIN_VALIDATE":"validate","BTN_CLOSE":"Fermer","BTN_SAVE_CREATE_APPARTMENT":"SAVE AND CREATE APPARTMENTS","BTN_MAJ":"update","BTN_DISABLE":"Disable","BTN_ENABLE":"Enable"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/button/button.en.json
// module id = QUQf
// module chunks = 0